<template>
    <svg width="30" height="55" viewBox="0 0 30 55" xmlns="http://www.w3.org/2000/svg">
        <path d="M30 0v40c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15V0h30zm-9.29 21.797a3.577 3.577 0 0 0-2.942-.716 3.463 3.463 0 0 0-2.6 1.94c-.055.109-.097.223-.146.336-.005-.004-.011-.006-.015-.01a3.349 3.349 0 0 0-1.134-1.563 3.73 3.73 0 0 0-3.562-.536 3.456 3.456 0 0 0-2.052 1.965 3.563 3.563 0 0 0-.161 2.039c.142.728.417 1.421.81 2.044.48.766 1.046 1.472 1.686 2.103.75.76 1.554 1.46 2.408 2.094.53.397 1.06.797 1.59 1.195l.43.322.976-.733c.68-.516 1.382-1.003 2.024-1.563.46-.402.913-.817 1.352-1.241.522-.504.996-1.056 1.416-1.651a6.219 6.219 0 0 0 1.193-2.848 3.658 3.658 0 0 0-.019-1.123 3.286 3.286 0 0 0-1.254-2.054z" fill="#F796A1" fill-rule="evenodd"/>
    </svg>
</template>

<script>
export default {
    name: 'IconFavoritePinMobile',
};
</script>
